export default {
	types: {
		phone: "Teléfono",
	},
};
